import { useState } from 'react';
import { bikingTrails } from '../../../mocks/transportationPage';

export default function BikingSection() {
  const [expandedTrail, setExpandedTrail] = useState<number | null>(null);

  return (
    <section id="biking" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <span className="inline-block bg-green-100 text-green-700 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wide mb-4">
              Cycling &amp; Trails
            </span>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Bike-Friendly Roseville
            </h2>
            <p className="text-gray-600 text-sm mb-6">
              With over 45 miles of dedicated bike trails and lanes, Roseville is a
              cyclist&rsquo;s paradise. Whether you&rsquo;re commuting to work or
              enjoying a weekend ride, our trail network connects parks,
              shopping, and neighborhoods.
            </p>

            <div className="grid grid-cols-2 gap-4 mb-8">
              <div className="bg-green-50 rounded-xl p-4 text-center">
                <p className="text-3xl font-bold text-green-700">45+</p>
                <p className="text-sm text-green-600">Miles of Trails</p>
              </div>
              <div className="bg-green-50 rounded-xl p-4 text-center">
                <p className="text-3xl font-bold text-green-700">12</p>
                <p className="text-sm text-green-600">Bike Repair Stations</p>
              </div>
              <div className="bg-green-50 rounded-xl p-4 text-center">
                <p className="text-3xl font-bold text-green-700">100%</p>
                <p className="text-sm text-green-600">Buses w/ Bike Racks</p>
              </div>
              <div className="bg-green-50 rounded-xl p-4 text-center">
                <p className="text-3xl font-bold text-green-700">Free</p>
                <p className="text-sm text-green-600">Trail Access</p>
              </div>
            </div>

            <div className="relative w-full h-64 rounded-xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/a683c7cf3a2e5669ae116c0c943faaee.jpg"
                alt="Roseville Bike Trail"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center space-x-2">
              <i className="ri-route-line text-green-600"></i>
              <span>Popular Trails</span>
            </h3>
            <div className="space-y-4">
              {bikingTrails.map((trail) => (
                <div
                  key={trail.id}
                  onClick={() =>
                    setExpandedTrail(
                      expandedTrail === trail.id ? null : trail.id
                    )
                  }
                  className={`bg-white rounded-xl p-5 border-2 transition-all cursor-pointer ${
                    expandedTrail === trail.id
                      ? 'border-green-400 shadow-md'
                      : 'border-gray-100 hover:border-green-200 hover:shadow-sm'
                  }`}
                >
                  <div className="flex items-start justify-between mb-2">
                    <div>
                      <h4 className="font-semibold text-gray-900">
                        {trail.name}
                      </h4>
                      <div className="flex items-center space-x-3 mt-1">
                        <span className="text-xs text-gray-500 flex items-center space-x-1">
                          <i className="ri-route-line"></i>
                          <span>{trail.distance}</span>
                        </span>
                        <span
                          className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                            trail.difficulty === 'Easy'
                              ? 'bg-green-100 text-green-700'
                              : 'bg-amber-100 text-amber-700'
                          }`}
                        >
                          {trail.difficulty}
                        </span>
                        <span className="text-xs text-gray-500">
                          {trail.surface}
                        </span>
                      </div>
                    </div>
                    <i
                      className={`ri-arrow-${
                        expandedTrail === trail.id ? 'up' : 'down'
                      }-s-line text-gray-400 mt-1`}
                    ></i>
                  </div>

                  <p className="text-gray-600 text-sm">{trail.description}</p>

                  {expandedTrail === trail.id && (
                    <div className="mt-4 pt-4 border-t border-gray-100 space-y-3">
                      <div>
                        <p className="text-xs font-semibold text-gray-700 mb-2">
                          Highlights:
                        </p>
                        <div className="flex flex-wrap gap-2">
                          {trail.highlights.map((h, idx) => (
                            <span
                              key={idx}
                              className="text-xs bg-green-50 text-green-700 px-3 py-1 rounded-full"
                            >
                              {h}
                            </span>
                          ))}
                        </div>
                      </div>

                      <div className="flex items-start space-x-2 text-sm text-gray-600">
                        <i className="ri-map-pin-line text-green-500 mt-0.5"></i>
                        <span>{trail.trailhead}</span>
                      </div>

                      <a
                        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                          trail.trailhead + ', Roseville, CA'
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center space-x-1 text-sm text-green-600 hover:text-green-700 font-medium cursor-pointer"
                      >
                        <i className="ri-direction-line"></i>
                        <span>Get Directions</span>
                      </a>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
